import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useStyles from "./calendar-toolbar.style";
import CalendarToday from "@iconify/icons-mdi/calendar-today";
import ChevronLeft from "@iconify/icons-mdi/chevron-left";
import ChevronRight from "@iconify/icons-mdi/chevron-right";
import ViewModuleOutline from "@iconify/icons-mdi/view-module-outline";
import ViewStreamOutline from "@iconify/icons-mdi/view-stream-outline";
import { InlineIcon } from "@iconify/react";

interface MyTimeCalendarToolbarProps {
  view: string;
  onView: (view: string) => void;
  onNavigate: (action: "PREV" | "NEXT" | "TODAY") => void;
  date: Date;
  monthFiltering: boolean;
}

export const MyTimeCalendarToolbar = (props: MyTimeCalendarToolbarProps) => {
  const { i18n } = useTranslation();
  let { view, onView, onNavigate, date, monthFiltering } = props;
  let title = moment(date).locale(i18n.language).format("YYYY. MMMM");
  const iconSize = 30;

  if (view === "week") {
    let start = moment(date)
      .locale(i18n.language)
      .startOf("week")
      .format("YYYY. MMMM D.");
    let end = moment(date)
      .locale(i18n.language)
      .endOf("week")
      .format("YYYY. MMMM D");
    if (i18n.language !== "hu") {
      start = moment(date)
        .locale(i18n.language)
        .startOf("week")
        .format("DD/MM/YYYY");
      end = moment(date)
        .locale(i18n.language)
        .endOf("week")
        .format("DD/MM/YYYY");
    }
    title = `${start} - ${end}.`;
  }

  const classes = useStyles({ monthFiltering });

  return (
    <div className={classes.toolbarMainContainer}>
      {view === "week" ? (
        <div className={classes.centerContainer}>
          <InlineIcon
            icon={ChevronLeft}
            width={iconSize}
            height={iconSize}
            className={classes.leftChevron}
            onClick={() => onNavigate("PREV")}
          />
          <span className={classes.title}>{title}</span>
          <InlineIcon
            icon={ChevronRight}
            width={iconSize}
            height={iconSize}
            className={classes.rightChevron}
            onClick={() => onNavigate("NEXT")}
          />
        </div>
      ) : (
        <div></div>
      )}
      <div
        style={{
          paddingTop: 2,
        }}
      >
        <InlineIcon
          icon={CalendarToday}
          width={iconSize}
          height={iconSize}
          onClick={() => onNavigate("TODAY")}
          className={view !== "day" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <div style={{ display: "inline-block", width: 24, height: 24 }}></div>
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewModuleOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("month")}
          className={view !== "month" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewStreamOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("week")}
          className={view !== "week" ? classes.icon : classes.iconDisabled}
        />
      </div>
    </div>
  );
};

export default MyTimeCalendarToolbar;
